import { render, staticRenderFns } from "./loginCX.vue?vue&type=template&id=07971652"
import script from "./loginCX.vue?vue&type=script&lang=js"
export * from "./loginCX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports